import React from 'react';
import {get} from 'lodash';
import moment from 'moment';

import ImageLoader from '../ImageLoader';
import CursorBasedList, { loadViaApi } from '../CursorBasedList';

const GiftTransactions = ({
  endpoint,
  otherRole
}) => {

  const renderItems = (items) => items.map((item, i) => {
    const { id, nickname, profile_icon_thumbnail } = get(item, otherRole) || {}
    return <div key={i} className='Table__row'>
      <div className='Table__col'>
        <div className='ImageBorder'>
          <ImageLoader url={profile_icon_thumbnail} />
        </div>
      </div>
      <div className='Table__col'>
        <a className='Table__a' href={`/${gon.currentProvider}/users/${id}`}>{id}</a>
      </div>
      <div className='Table__col'>
        {nickname}
      </div>
      <div className='Table__col'>
        {item.context}
      </div>
      <div className='Table__col'>
        {moment.unix(item.created_at).format('YYYY-MM-DD HH:mm')}
      </div>
      <div className='Table__col Table__col--flex-items'>
        {item.gifts.map((gift, j) => (
          <div className='GiftIcon' key={j}>
            <span className='GiftIcon__qty_label'>{gift.quantity}x</span>
            <ImageLoader url={gift.icon} />
            <span className='GiftIcon__qty_label'>{get(gift, 'title')}</span>
          </div>
        ))}
      </div>
    </div>
  })

  return (
    <CursorBasedList
      fetchData={loadViaApi(endpoint)}
      renderItems={renderItems}
      tableClass='Table--gift-history'
    >
      <div className='Table__row'>
        <div className='Table__col Table__col--th'>Photo</div>
        <div className='Table__col Table__col--th'>ID</div>
        <div className='Table__col Table__col--th'>Nickname</div>
        <div className='Table__col Table__col--th'>Context</div>
        <div className='Table__col Table__col--th'>Date</div>
        <div className='Table__col Table__col--th'>Gifts</div>
      </div>
    </CursorBasedList>
  )
}

export default GiftTransactions
